import React from "react";

const Contact = () => {
  return (
    <>
      <div>
        <h1 className="text-white text-3xl items-center text-center p-4 py-32">
          {" "}
          This form will submit a ticket in our helpdesk. A representative will
          be in touch by email.
        </h1>
      </div>
      <div className="contact-container flex items-center justify-center min-h-screen">
        <iframe
          id="zsfeedbackFrame"
          name="zsfeedbackFrame"
          scrolling="no"
          allowTransparency="false"
          frameBorder="0"
          border="0"
          src="https://desk.zoho.com/support/fbw?formType=AdvancedWebForm&fbwId=edbsn8d0027cfb03448de4e1961a57dc02b111ee3ebb61261afd2f5eee9fdebf262ec&xnQsjsdp=edbsnbb33b714d57d2eceb43d0325b954bfe8&mode=showNewWidget&displayType=iframe"
          style={{ width: "100%", height: "100vh" }}
        />
      </div>
    </>
  );
};

export default Contact;
